import React from "react";
import { Button } from "@mui/material";
import AuthService from "../../utils/AuthService";
import GameServer from "./GameServer";

function GameStartLink({
  gameCode,
  onGameStart,
  label = "START GAME",
  startIcon,
}) {
  const handleStartClick = () => {
    console.log("🎮 Launching game:", gameCode);

    // just notify once
    GameServer.notify({
      gameCode,
      event: "launchgame",
      payload: { launch: "game..." },
    });

    // trigger parent callback if needed
    if (onGameStart) onGameStart();
  };

  return (
    <Button
      variant="contained"
      color="primary"
      onClick={handleStartClick}
      startIcon={startIcon}
      sx={{ borderRadius: 30, px: 3 }}
    >
      {label}
    </Button>
  );
}

export default GameStartLink;
